import React, { Component } from 'react'

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';
import { BrowserRouter as Router, withRouter, Link,  } from 'react-router-dom';

// Custom components
import CompanyInterfaceForm, {
    ComponentWrapper,
    FormWrapper,
    FormSectionWrapper,
    TopContainer,
    LinkWrapper,
    FormRowWrapper,
    FormColumnWrapper
} from 'containers/CompanyContainer/CompanyInterfaceForm';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';
import CompanyBreadcrumbs from 'components/Assests/CompanyBreadcrumbs';

// Constants
import { constants } from 'constants/index';

class ServiceSetupForm extends CompanyInterfaceForm {

    state = {
        name : '',
        description: '',
        type: '',
        consultDuration: undefined,
        serviceDuration: undefined,
        price: undefined,
        //goals: [],
        modules: [],
        provider: null,
        coverPhotoURL: null,
        isLoading: false
    }

    componentDidMount(){
        const { state } = this;
        const { service, providers, userData, getCompanyInfo, getDBServiceModules } = this.props;

        getDBServiceModules();

        const itemValues = {};
        let formattedServiceData = {}
        const serviceDataIsValid = serviceItem => Object.keys(serviceItem || {}).length > 0;
        if(serviceDataIsValid(service)){
            const setItemValues = valueKey => itemValues[valueKey] = formattedServiceData[valueKey];
            formattedServiceData = { ...service };
            Object.keys(state).forEach(setItemValues);
            itemValues['price'] = itemValues['price']/100;
            this.setState(itemValues);
        }

        const employeeDataIsEmpty= providers => providers.length === 0;
        if(employeeDataIsEmpty(providers)){
            getCompanyInfo(userData.providerCompany);
        }

        this.hydrateStateWithLocalStorage();

        window.addEventListener(
            "beforeunload",
            this.saveStateToLocalStorage.bind(this)
        );
    };

    // getGoals = (goal, index) => {
    //     const { name, description } = goal;
    //     return(
    //         <FieldsetWrapper>
    //             <FieldsetHeaderWrapper>
    //                 <FieldsetTitleWrapper>Goal #{index+1}</FieldsetTitleWrapper>
    //                 <RemoveButton
    //                     onClick={(e) => this.handleFieldsetRemoval(event, 'goals', index)}
    //                     type="button"
    //                 >
    //                     Remove
    //                 </RemoveButton>
    //             </FieldsetHeaderWrapper>
    //             <FormTextField
    //                 label="Name"
    //                 name="name"
    //                 onChange={(e) => this.handleChange(e, 'goals', index)}
    //                 value = { name }
    //                 secondaryIconType="pencil-alt"
    //                 required={true}
    //             />
    //             <FormTextArea
    //                 label="Write a description..."
    //                 name={"description"}
    //                 onChange={(e) => this.handleChange(e, 'goals', index)}
    //                 value = { description }
    //                 required={true}
    //             />
    //         </FieldsetWrapper>
    //     )
    // }

    setFieldsetDefaultValues = (name) => {
        const { modules } = this.props;
        return name === 'modules'
            ? [{
                type: modules && modules[0] && modules[0]._id,
                description: ''
            }]
            : [{}]
    };


    getTopContainerActions = () => {
        return (
            <React.Fragment>
                <CompanyPageButton
                    test-label="saveButton"
                    type={'dark'}
                    size={'small'}
                    children={'Save'}
                />
                <LinkWrapper to='/company/dashboard'>Back to Dashboard ></LinkWrapper>
            </React.Fragment>
        )
    }

    getFormFields = () => {
        return (
            <React.Fragment>
                <FormRowWrapper>
                    <FormColumnWrapper>
                        {this.getServiceGeneralInformationFields()}
                        {this.getCoverPhotoField({subTitle: "Upload an image that represents this service."})}
                    </FormColumnWrapper>
                    <FormColumnWrapper>
                        {this.getServiceDetailsFields()}
                    </FormColumnWrapper>
                </FormRowWrapper>
            </React.Fragment>
        );
    }

    formatServiceDataForDB = (event) => {
        event.preventDefault();
        const {
            name,
            description,
            type,
            serviceDuration,
            consultDuration,
            price,
            //goals,
            modules,
            provider,
            coverPhotoURL
        } = this.state;
        const { service } = this.props;

        const convertDollarsToCents = price => price * 100;
        const selectedProvider = provider || this.props.providers[0]; // IF THE USER DOES NOT SELECT AN USER, AND LEAVES THE ONE THAT APPEARS AS DEFAULT SELECTED
        const providerUid = selectedProvider && selectedProvider.uid || selectedProvider;
        const formattedServiceData = {
            _id: service ? service._id : null,
            name,
            description,
            type,
            serviceDuration,
            consultDuration,
            duration: serviceDuration,
            price: convertDollarsToCents(price),
            //goals,
            modules : modules || [],
            provider: providerUid,
            coverPhotoURL
        }

        window.removeEventListener(
            "beforeunload",
            this.saveStateToLocalStorage.bind(this)
        );

        this.setState({ isLoading: true});
        service
            ? this.updateInfo(formattedServiceData)
            : this.saveInfo(formattedServiceData);
        //TODO ADD VALIDATION
    }

    saveInfo = (formattedServiceData) => {
        console.log('saving item');
        this.props.addCompanyItem({
            companyId: this.props.userData.providerCompany,
            itemData: formattedServiceData,
            itemType: 'services'
        })
        .then( success => {
            success
                ? this.props.history.push('/company/dashboard')
                : console.log('reset');
        })
    }

    updateInfo = (formattedServiceData) => {
        console.log('updating item');
        this.props.updateCompanyItem({
            companyId: this.props.userData.providerCompany,
            itemData: formattedServiceData,
            itemType: 'services'
        })
        .then( success => {
            success
                ? this.props.history.push('/company/dashboard')
                : console.log('reset');
        })
    }


    render () {
        const {
            getTopContainerActions,
            getFormFields,
            formatServiceDataForDB,
            getLoader
        } = this;
        const companyRoles = this.props.userData && this.props.userData.roles;

        let loader = getLoader();
        return (
            <ComponentWrapper>
                { this.props.match && this.props.match.url &&
                    <CompanyBreadcrumbs
                        // employeeId={this.props.employee && this.props.employee.uid}
                        location={this.props.match.url}
                        path={this.props.match.path}
                        companyRoles = {companyRoles}
                    />
                }
                {loader}
                <FormWrapper onSubmit={formatServiceDataForDB}>
                    <TopContainer>
                        {getTopContainerActions()}
                    </TopContainer>
                    {getFormFields()}
                </FormWrapper>
            </ComponentWrapper>
        )
    }
}

const mapStateToProps = ({company, client, service}) => ({
    service: company.selectedService,
    providers: company.providers,
    formSubmissionSuccessful: company.formSubmissionSuccessful,
    userData: client.clientData,
    modules: service.modules
});

export default withRouter(connect(mapStateToProps,actions)(ServiceSetupForm));


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/ServiceSetupForm.jsx